import React from 'react';
import {
  FileField,
  SimpleShowLayout,
  TextField,
  useTranslate,
} from 'react-admin';
import SectionTitle from '../SectionTitle';

import './styles.scss';

// The test review pages pass `hideLabReport` and render the lab report themselves,
// below the test history.
const ImmunotherapyAnswers = ({
  record,
  hideLabReport = false,
}: {
  record?: Record<string, any>;
  hideLabReport?: boolean;
}) => {
  const translate = useTranslate();

  const dataSource = record?.test ? 'test.answers' : 'answers';
  const labReportSource = record?.test ? 'test.labReport' : 'labReport';

  return (
    <>
      <SectionTitle
        title={translate('immunotherapy.patientAnswers')}
        className="immunotherapyAnswers__title"
      />
      <div className="immunotherapyAnswers__column-wrapper">
        <SimpleShowLayout className="immunotherapyAnswers__column">
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.allergiesNames`}
            label="immunotherapy.patient.allergiesNames"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.otherAllergies`}
            label="immunotherapy.patient.otherAllergies"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.allergySymptomsExperienced`}
            label="immunotherapy.patient.symptoms"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.purposeOfTakingTest`}
            label="immunotherapy.patient.purposeOfTakingTest"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.symptomsTiming`}
            label="immunotherapy.patient.symptomPeriod"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.durationMonths`}
            label="immunotherapy.patient.durationMonths"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.sinceWhenAllergySymptomsOccur`}
            label="immunotherapy.patient.symptomsOccurrenceYear"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.howSymptomsEvolved`}
            label="immunotherapy.patient.symptomsEvolution"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.factorsThatWorsenTheSymptoms`}
            label="immunotherapy.patient.symptomsWorseningFactors"
            emptyText="-"
          />
        </SimpleShowLayout>
        <SimpleShowLayout className="immunotherapyAnswers__column">
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.petsInHousehold`}
            label="immunotherapy.patient.petsAtHome"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.haveAsthma`}
            label="immunotherapy.patient.asthma"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.medicalConditions`}
            label="immunotherapy.patient.preExistingConditions"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.medicationName`}
            label="immunotherapy.patient.medicationName"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.immunotherapyTried`}
            label="immunotherapy.patient.immunotherapyTried"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.immunotherapyForWhichAllergens`}
            label="immunotherapy.patient.immunotherapyForWhichAllergens"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.lastImmunotherapy`}
            label="immunotherapy.patient.lastImmunotherapy"
            emptyText="-"
          />
          <TextField
            className="immunotherapyAnswers__textField"
            source={`${dataSource}.lastImmunotherapyDuration`}
            label="immunotherapy.patient.lastImmunotherapyDuration"
            emptyText="-"
          />
          {!hideLabReport && (
            <FileField
              target="_blank"
              className="text--purple"
              source={labReportSource}
              title={translate('testResults.openLabReport')}
              label="immunotherapy.patient.labReport"
            />
          )}
        </SimpleShowLayout>
      </div>
    </>
  );
};

export default ImmunotherapyAnswers;
